import React, { Fragment, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLoginContext } from "../context/LoginContext";

export default function Review() {
  const { userData, refresh } = useLoginContext();
  const Navigate = useNavigate();
  const [isCopied, setIsCopied] = useState(false);
  const shareUrl = `https://sparkpro.app/pre-registration?referId=${userData?.code}`;

  const handleCopyUrl = () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => setIsCopied(true))
      .catch(() => setIsCopied(false));

    setTimeout(() => setIsCopied(false), 1000); // Reset after 2 seconds
  };

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>

      

            <Row>
              <Col lg={8}>
                <div className=" mt-4  clients-reviews-box">
                  <div className="clients-reviews">
                     <h4>Refer a Friend</h4>
                    <p>
                    Share your referral link. When someone registers and subscribes using your link, you’ll earn 5 credits as a thank you!
                    </p> 
                    <div className="copu-with-link">
                      <div className="input-box-field">
                        {isCopied && (
                          <span className="copy-status color-red">Copied!</span>
                        )}
                        <Fragment style={{ display: "flex" }}>
                          <Form.Group className=" copy-link">
                            <input
                              type="text"
                              className="form-control"
                              value={shareUrl}
                              readOnly
                              // className="form-control"
                            />
                          </Form.Group>
                        </Fragment>
                      </div>
                      <div className="copy-icon">
                        <span
                          className="link-copy-icon"
                          onClick={() => handleCopyUrl()}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 3H9C6.79086 3 5 4.79086 5 7V15"
                              stroke="black"
                              stroke-width="2"
                            />
                            <path
                              d="M9 11.5C9 10.304 9.00149 9.49062 9.0712 8.87226C9.13864 8.27406 9.25916 7.98334 9.41329 7.78248C9.51969 7.64381 9.64381 7.51969 9.78248 7.41329C9.98334 7.25916 10.2741 7.13864 10.8723 7.0712C11.4906 7.00149 12.304 7 13.5 7C14.696 7 15.5094 7.00149 16.1277 7.0712C16.7259 7.13864 17.0167 7.25916 17.2175 7.41329C17.3562 7.51969 17.4803 7.64381 17.5867 7.78248C17.7408 7.98334 17.8614 8.27406 17.9288 8.87226C17.9985 9.49062 18 10.304 18 11.5V15.5C18 16.696 17.9985 17.5094 17.9288 18.1277C17.8614 18.7259 17.7408 19.0167 17.5867 19.2175C17.4803 19.3562 17.3562 19.4803 17.2175 19.5867C17.0167 19.7408 16.7259 19.8614 16.1277 19.9288C15.5094 19.9985 14.696 20 13.5 20C12.304 20 11.4906 19.9985 10.8723 19.9288C10.2741 19.8614 9.98334 19.7408 9.78248 19.5867C9.64381 19.4803 9.51969 19.3562 9.41329 19.2175C9.25916 19.0167 9.13864 18.7259 9.0712 18.1277C9.00149 17.5094 9 16.696 9 15.5V11.5Z"
                              stroke="black"
                              stroke-width="2"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
